module.exports = __webpack_public_path__ + "img/cv_profile_lg.296e1a36.jpg";